import React from 'react';

import AdminSupportTickets from 'Components/Networking/AdminSupportTickets';

import AdminLayout from 'Pages/Admin/AdminLayout';

export default class SupportTickets extends React.Component {
    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        return (
            <AdminLayout title="Support Tickets">
                <div className="min-h-screen text-black">
                    <AdminSupportTickets 
                        selectedMessageToType='App\Models\SupportTicket'
                        selectedMessageToId={this.props.match?.params?.ticket}
                    />
                </div>
            </AdminLayout>
        )
    }
}